import { Object, Number, String, Array, Static } from '@sinclair/typebox';

export type TaxBreakdown = Static<typeof TaxBreakdown>;
export const TaxBreakdown = Object({
  code: String(),
  value: Number(),
  label: String(),
});

export type TaxesByPassengerType = Static<typeof TaxBreakdown>;
export const TaxesByPassengerType = Object({
  passengerType: String(),
  totalTax: Number(),
  totalFare: Number(),
  taxBreakdown: Array(TaxBreakdown),
});

export type Taxes = Static<typeof Taxes>;
export const Taxes = Object({
  totalTax: Number(),
  totalTaxBreakdown: Array(TaxBreakdown),
  taxByPassengerTypes: Array(TaxesByPassengerType),
});
